'use client'

import React, { createContext, useContext, useState } from 'react'

type DocumentPreviewContextType = {
  previewMimeType?: string
  previewUrl: string | null
  setPreviewUrl(url: string | null, mimeType?: string): void
}

const DocumentPreviewContext = createContext<DocumentPreviewContextType | undefined>(undefined)

export const DocumentPreviewProvider = ({ children }: { children: React.ReactNode }) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const [previewMimeType, setPreviewMimeType] = useState<string | undefined>(undefined)

  const handleSetPreviewUrl = (url: string | null, mimeType?: string) => {
    setPreviewUrl(url)
    setPreviewMimeType(mimeType)
  }

  return (
    <DocumentPreviewContext.Provider
      value={{ previewMimeType, previewUrl, setPreviewUrl: handleSetPreviewUrl }}
    >
      {children}
    </DocumentPreviewContext.Provider>
  )
}

export function useDocumentPreview() {
  const context = useContext(DocumentPreviewContext)

  if (context === undefined) {
    throw new Error('useDocumentPreview must be used within a DocumentPreviewProvider')
  }

  return context
}
